<main>
    <!-- HEADER -->
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <div class="header">
                <mat-card-title> {{"MASCHINESTATE.PRESSURE.HEADER" | translate}} </mat-card-title>

                
            </div>
        </mat-card-title-group>
        <!-- CONTENT -->
        <mat-card-content>
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >

                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true">
                    <div class="stack-wrapper">
                        <div class="background stack" id="wrapper">
                            <img
                                class="cabine-background"
                                id="image"
                                src="../../../../../../assets/images/machine/MachineSchematicCentered.svg"
                                alt=""
                                (load)="this.imgLoaded = true"
                            />
                        </div>

                        <ng-container *ngIf="this.imgLoaded == true">
                            <!-- Outrigger-Slew Values-->
                            <div class="value-block amp stack" id="outrigger-slew">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.SLEW" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Connection_Upper_Undercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Driving Values-->
                            <div class="value-block amp stack" id="drive">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.DRIVE_OUTRIGGER" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Undercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName |translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Machine Values-->
                            <div class="value-block amp stack" id="machine">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.MACHINE" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Main_Uppercarriage">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Boom Cylinder Values-->
                            <div class="value-block amp stack" id="boom-cylinder">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.BOOM" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Boom_Cylinder">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Stick Values-->
                            <div class="value-block amp stack" id="stick-cylinder">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.STICK" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Stick_Cylinder">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate }}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Tool Values-->
                            <div class="value-block amp stack" id="tool">
                                <div class="value-block-title">{{"MASCHINESTATE.PRESSURE.TOOL" | translate}}</div>
                                <div class="scrollable">
                                    <ng-container *ngFor="let datapoint of this.equipmentPressureDataset.dataPoints">
                                        <ng-container *ngIf="datapoint.position == this.positionEnum.Tool">
                                            <div class="datapoint borderred" id="wrapper">
                                                <div class="datapoint bordergreen" id="name">{{ datapoint.generalName | translate}}:</div>
                                                <div class="datapoint borderblue" id="value">{{ datapoint.value != 100794368 ? datapoint.value : '-' }} {{ datapoint.unit }}</div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
